import { useMemo } from 'react';

import { BoardSoil, BoardStatus } from 'features/Croptimizer/types';

interface Props {
  boardStatusValues: BoardStatus | null;
  boardSoilValues: BoardSoil | null;
}

const useImprovementInCost = ({
  boardStatusValues,
  boardSoilValues,
}: Props) => {
  const useImprovementInCostResult = useMemo(() => {
    const totalmtha = Math.ceil(Number(boardSoilValues?.totalMtha) * 100) / 100;
    const mtService =
      Number(boardSoilValues?.mt) + Number(boardSoilValues?.service);

    if (
      Number(boardStatusValues?.currentPh) < Number(boardStatusValues?.targetPh)
    ) {
      const v33 = Number(totalmtha);

      const v34 = v33 * mtService;

      return -v34;
    } else {
      const p39 = Number(totalmtha) / 1000;
      const p40 = p39 * mtService;
      const q40 = p40;
      const r40 = q40;
      const s40 = r40;
      const t40 = s40;
      const u40 = p40 + q40 + r40 + s40 + t40;

      return -u40;
    }
  }, [boardStatusValues, boardSoilValues]);

  return {
    useImprovementInCostResult,
  };
};

export default useImprovementInCost;
